import React, { useEffect, useState, useRef } from "react";
import { API } from "../../config/api";
import { ApiHelper } from "../../helpers/ApiHelper";
import Menu from "../../assets/images/menu.svg";
import Spinner from "../../components/Spinner";
import draftToHtml from "draftjs-to-html";
import {
  EditorState,
  ContentState,
  convertFromHTML,
  convertToRaw,
  convertFromRaw,
  convertToHTML,
} from "draft-js";
import dropdown from "../../assets/images/dropdown.svg";
import Alert from "../../assets/images/alert-circle.svg";
import warning from "../../assets/images/alert-triangle.svg";
import success from "../../assets/images/success.svg";
import uparrow from "../../assets/images/arrow-up.svg";
import Logo from "../../assets/images/TKC-Logo1.png";
import LogoPw from "../../assets/images/Logo.png";
import Info from "../../assets/images/help.svg";
import Video from "../../assets/images/video-thumb.svg";
import Doc from "../../assets/images/doc.svg";
import Closes from "../../assets/images/Close.svg";
// import alertR from '../../assets/images/alert-circleRed'
import File from "../../assets/images/file.svg";
import Disc from "../../assets/images/round.svg";
import Download from "../../assets/images/download.svg";
import close from "../../assets/images/Close.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { Close } from "@material-ui/icons";
// import { Document, Page } from 'react-pdf'
import pdf from "../../assets/payment.pdf";
import FillablePdf from "../Onboarding/pdfFiller";
import moment from "moment";
import "../../assets/css/responsive.css";
import eye from "../../assets/images/eye.png";
import eyeview from "../../assets/images/view.png";
import W4form from "../legalforms/W4form";
import I9form from "../legalforms/I9form";
import W4South from "../legalforms/W4South";

const Candidate = () => {
  const navigate = useNavigate();
  const [sections, setSections] = useState([]);
  const [deadLine, setDeadLine] = useState(null);
  const [deadLineDays, setDeadLineDays] = useState(null);
  const [tempData, setTempData] = useState({});
  const [itemObj, setItemObj] = useState(null);
  const [converted64, setConverted64] = useState();
  const [loader, setLoader] = useState(false);
  const [pdfViewer, setPdfViewer] = useState(false);
  const [componentItem, setComponentItem] = useState();
  const [companyLogo, setCompanyLogo] = useState("");
  const [formData, setFormData] = useState([]);
  const location = useLocation();
  console.log(location);
  const currentPath = location.pathname;
  const parts = currentPath.split("/");

  useEffect(() => {
    console.log(location.state?.chatbotId);
    // if (location.state?.formData !== undefined)
    //   setFormData(JSON.parse(location?.state?.formData));
    // else
    if (location?.state?.tempId !== undefined) {
      viewForm();
    } else if (location?.state?.formId !== undefined) {
      getFormTemplate();
    } else if (location?.state?.formid !== undefined) {
      viewFormTemplate();
    } else if (location?.state?.formTempId !== undefined) {
      viewFormTemplate();
    } else if (location.state?.chatbotId === undefined) viewTemplate();
    else fetchSections(location.state?.chatbotId);
  }, []);

  useEffect(() => {
    console.log(sections, tempData, tempData?.fields);

    if (sections?.length !== 0) {
      if (
        location.state?.tempId !== undefined ||
        location.state?.formId !== undefined ||
        location.state?.formTempId !== undefined ||
        location.state?.formid !== undefined
      )
        createFormTempData();
      else if (location.state?.chatbotId === undefined) createtempData();
      else createFormData();
    }
  }, [sections]);

  // useEffect(() => {
  //   console.log(tempData, tempData?.fields);
  //   if (tempData?.fields !== undefined) {
  //     if (
  //       location.state?.tempId !== undefined ||
  //       location.state?.formId !== undefined ||
  //       location.state?.formTempId !== undefined ||
  //       location.state?.formid !== undefined
  //     )
  //       createFormTempData();
  //     else if (location.state?.chatbotId === undefined) createtempData();
  //     else createFormData();
  //   }
  // }, [tempData]);

  const fetchSections = async (id) => {
    setLoader(true);
    const formData = {
      chatbotid: id,
    };
    await ApiHelper.post(API.getSections, formData)
      .then((resData) => {
        console.log(resData);
        if (resData.data.success === true) {
          setSections(resData.data.data);
          setCompanyLogo(resData?.data?.companyLogo);
          setDeadLineDays(resData.data?.options?.deadline);
          let today = new Date();
          let deadline = resData.data?.options?.deadline;
          let deadlinedate = new Date(today);
          deadlinedate.setDate(today.getDate() + deadline);
          setDeadLine(deadlinedate);
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  const viewTemplate = async () => {
    setLoader(true);
    let tempData = JSON.parse(localStorage.getItem("Tempdata"));
    const formData = {
      templateid: tempData?.id,
    };
    await ApiHelper.post(API.getTemplateDetails, formData)
      .then((resData) => {
        console.log(resData);
        if (resData.data.success === true) {
          console.log(resData?.data?.templateData[0]);
          setSections(resData?.data?.templateData[0]?.template_data);
          setDeadLineDays(resData?.data?.templateData[0]?.deadline);
          let today = new Date();
          let deadline = resData.data?.templateData[0]?.deadline;
          let deadlinedate = new Date(today);
          deadlinedate.setDate(today.getDate() + deadline);
          setDeadLine(deadlinedate);
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  const viewForm = async () => {
    setLoader(true);
    let tempData = JSON.parse(localStorage.getItem("Tempdata"));
    const formData = {
      template_id: location?.state?.tempId,
    };
    await ApiHelper.post(API.getTemplateById, formData)
      .then((resData) => {
        console.log(resData);
        if (resData.data.success === true) {
          setTempData(resData?.data?.data[0]);
          createFormTempData(resData?.data?.data[0]);
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  const viewFormTemplate = async () => {
    setLoader(true);
    let tempData = JSON.parse(localStorage.getItem("Tempdata"));
    const formData = {
      form_id:
        location?.state?.formid !== undefined
          ? location?.state?.formid
          : location?.state?.formTempId,
    };
    await ApiHelper.post(API.getTemplateFormById, formData)
      .then((resData) => {
        console.log(resData);
        if (resData.data.success === true) {
          setTempData(resData?.data?.data[0]);
          createFormTempData(resData?.data?.data[0]);
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  const getFormTemplate = async () => {
    setLoader(true);
    const formData = {
      form_id: location?.state?.formId,
    };
    await ApiHelper.post(API.getFormById, formData)
      .then((resData) => {
        console.log(resData);
        if (resData.data.success === true) {
          setTempData(resData?.data?.data[0]);
          createFormTempData(resData?.data?.data[0]);
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };
  function downloadFile(filepath) {
    const link = document.createElement("a");
    link.href = filepath;
    link.download = "avenu";
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const handleFillablePdf = async (item) => {
    setLoader(true);
    let newItemObj;
    const obj = {
      formfieldid: item.id,
    };
    try {
      const result = await ApiHelper.post(
        API.onboardingGetSectionConvertedDocument,
        obj
      );
      newItemObj = {
        file_buffer_encrypted_value: result.data.b64Doc,
        id: item.id,
      };
      setPdfViewer(true);
      setComponentItem(newItemObj);
      setLoader(false);
    } catch (err) {
      console.log("err", err);
    }
  };

  const createFormData = () => {
    let x = JSON.parse(JSON.stringify(sections));
    for (let k = 0; k < x.length; k++) {
      for (let i = 0; i < x[k].section_forms?.length; i++) {
        let array = [];
        for (let j = 0; j < x[k].section_forms[i]?.fields?.length; j++) {
          if (x[k].section_forms[i]?.fields[j]?.field_type_id === 1) {
            array.push(x[k].section_forms[i]?.fields[j]);
          }
          if (x[k].section_forms[i]?.fields?.[j].field_type_id === 2) {
            array.push(x[k].section_forms[i]?.fields[j]);
          }
          if (x[k].section_forms[i]?.fields?.[j].field_type_id === 3) {
            array.push(x[k].section_forms[i]?.fields[j]);
          }
          if (x[k].section_forms[i]?.fields?.[j].field_type_id === 4) {
            array.push(x[k].section_forms[i]?.fields[j]);
          }
          if (x[k].section_forms[i]?.fields?.[j].field_type_id === 5) {
            array.push(x[k].section_forms[i]?.fields[j]);
          }
          if (x[k].section_forms[i]?.fields?.[j].field_type_id === 6) {
            array.push(x[k].section_forms[i]?.fields[j]);
          }
          if (x[k].section_forms[i]?.fields?.[j].field_type_id === 7) {
            array.push(x[k].section_forms[i]?.fields[j]);
          }
          if (x[k].section_forms[i]?.fields?.[j].field_type_id === 9) {
            array.push(x[k].section_forms[i]?.fields[j]);
          }
          if (x[k].section_forms[i]?.fields?.[j].field_type_id === 11) {
            array.push(x[k].section_forms[i]?.fields[j]);
          }
          if (x[k].section_forms[i]?.fields?.[j].field_type_id === 13) {
            array.push(x[k].section_forms[i]?.fields[j]);
          }
          if (x[k].section_forms[i]?.fields?.[j].field_type_id === 14) {
            let obj = x[k].section_forms[i]?.fields[j];
            obj.isVisible = false;
            array.push(obj);
          }
          array.isFormConfirmed =
            x[k].section_forms[i].completed_status === 0 ? false : true;
        }
        x[k].section_forms[i]?.fields.splice(
          0,
          x[k].section_forms[i]?.fields.length,
          array
        );
      }
    }
    console.log(x);
    setFormData(x);
  };

  const createtempData = () => {
    let x = JSON.parse(JSON.stringify(sections));
    for (let k = 0; k < x.length; k++) {
      for (let i = 0; i < x[k].template_forms?.length; i++) {
        let array = [];
        for (let j = 0; j < x[k].template_forms[i]?.fields?.length; j++) {
          if (x[k].template_forms[i]?.fields[j]?.field_type_id === 1) {
            array.push({});
          }
          if (x[k].template_forms[i]?.fields?.[j].field_type_id === 2) {
            array.push({});
          }
          if (x[k].template_forms[i]?.fields?.[j].field_type_id === 3) {
            array.push({});
          }
          if (x[k].template_forms[i]?.fields?.[j].field_type_id === 4) {
            array.push({});
          }
          if (x[k].template_forms[i]?.fields?.[j].field_type_id === 5) {
            array.push({});
          }
          if (x[k].template_forms[i]?.fields?.[j].field_type_id === 6) {
            array.push({});
          }
          if (x[k].template_forms[i]?.fields?.[j].field_type_id === 7) {
            array.push({});
          }
          if (x[k].template_forms[i]?.fields?.[j].field_type_id === 9) {
            array.push({});
          }
          if (x[k].template_forms[i]?.fields?.[j].field_type_id === 11) {
            array.push({});
          }
          if (x[k].template_forms[i]?.fields?.[j].field_type_id === 13) {
            array.push({});
          }
          if (x[k].template_forms[i]?.fields?.[j].field_type_id === 14) {
            array.push({
              isVisible: false,
            });
          }
          array.isFormConfirmed =
            x[k].template_forms[i].completed_status === 0 ? false : true;
        }
        x[k].template_forms[i]?.fields.splice(
          0,
          x[k].template_forms[i]?.fields.length,
          array
        );
      }
    }
    console.log(x);
    setFormData(x);
  };

  const createFormTempData = (tempData) => {
    let array = [];
    console.log(tempData);
    for (let j = 0; j < tempData?.fields?.length; j++) {
      if (tempData.fields[j]?.field_type_id === 1) {
        array.push({});
      }
      if (tempData?.fields[j]?.field_type_id === 2) {
        array.push({});
      }
      if (tempData?.fields[j]?.field_type_id === 3) {
        array.push({});
      }
      if (tempData?.fields[j]?.field_type_id === 4) {
        array.push({});
      }
      if (tempData?.fields[j]?.field_type_id === 5) {
        array.push({});
      }
      if (tempData?.fields[j]?.field_type_id === 6) {
        array.push({});
      }
      if (tempData?.fields[j]?.field_type_id === 7) {
        array.push({});
      }
      if (tempData?.fields[j]?.field_type_id === 9) {
        array.push({});
      }
      if (tempData?.fields[j]?.field_type_id === 11) {
        array.push({});
      }
      if (tempData?.fields[j]?.field_type_id === 13) {
        array.push({});
      }
      if (tempData?.fields[j]?.field_type_id === 14) {
        array.push({
          isVisible: false,
        });
      }
      // array.isFormConfirmed =
      //   x[k].template_forms[i].completed_status === 0 ? false : true;
    }
    // x[k].template_forms[i]?.fields.splice(
    //   0,
    //   x[k].template_forms[i]?.fields.length,
    //   array
    // );

    console.log(array);
    setFormData(array);
  };

  const convert = (item, index, i, j) => {
    console.log("item", item);
    if (item && item.field_type_id === 13) {
      return (
        <div className="btnAlg_same">
          <button
            className="btn btn-primary my-2 review-btn"
            onClick={() => handleFillablePdf(item)}
          >
            Review Document
          </button>
        </div>
      );
    }

    if (item.field_type_id === 9) {
      return (
        <div style={{ marginBottom: "25px" }}>
          <div
            dangerouslySetInnerHTML={{
              __html: draftToHtml(
                location?.state?.formData !== undefined
                  ? item.field_value
                  : JSON.parse(item.field_value)
              ),
            }}
          />
          {location?.state?.formData !== undefined
            ? item?.options.map((item) => {
                return (
                  <div className="form-check my-3">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="flexRadioDefault2"
                    />
                    <label className="form-check-label" for="flexRadioDefault1">
                      {item.option}
                    </label>
                  </div>
                );
              })
            : item?.field_options.map((item) => {
                return (
                  <div className="form-check my-3">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="flexRadioDefault2"
                    />
                    <label className="form-check-label" for="flexRadioDefault1">
                      {item.options}
                    </label>
                  </div>
                );
              })}
        </div>
      );
      // Render the checkbox component here
    } else if (
      item.field_type_id === 3 ||
      item.field_type_id === 4 ||
      item.field_type_id === 5 ||
      item.field_type_id === 7
    ) {
      if (item.field_type_id === 4) {
        return (
          <div>
            <div
              dangerouslySetInnerHTML={{
                __html: draftToHtml(
                  location?.state?.formData !== undefined
                    ? item.field_value
                    : JSON.parse(item.field_value)
                ),
              }}
            />
            <video
              src={API.mediaView + item.file_path}
              alt="copy"
              className="video-thumb my-2"
              controls
            />
          </div>
        );
      }
      if (item.field_type_id === 5) {
        return (
          <div>
            <div className="form-check sign-padd-preview">
              <input
                className="form-check-input"
                type="checkbox"
                value=""
                id="flexCheckDefault"
              />
              <label className="form-check-label" for="flexCheckDefault">
                {item.field_value}
              </label>
            </div>

            <div className="q-btns my-3 d-flex justify-content-between">
              <div className="row w-100">
                <div className="col-lg-4">
                  <div className="form-floating minH mb-3">
                    <input
                      type="email"
                      className="form-control signs"
                      id="floatingInput"
                      placeholder="name@example.com"
                    />
                    <label for="floatingInput" className=" font-enter-color">
                      Sign Here
                    </label>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-floating minH mb-3">
                    <input
                      type="email"
                      className="form-control"
                      id="floatingInput"
                      placeholder="name@example.com"
                    />
                    <label for="floatingInput" className=" font-enter-color">
                      Date
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      }
      if (item.field_type_id === 7) {
        return (
          <div>
            <div
              dangerouslySetInnerHTML={{
                __html: draftToHtml(
                  location?.state?.formData !== undefined
                    ? item.field_value
                    : JSON.parse(item.field_value)
                ),
              }}
            />
            <div className="d-flex py-2">
              <div className="inpWid">
                <div className="inptFiles_up">
                  <input type="file" />
                  <button type="button" className="upBtn">
                    Upload
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      }
      return (
        <div class="wraper">
          <div
            dangerouslySetInnerHTML={{
              __html: draftToHtml(
                location?.state?.formData !== undefined
                  ? item.field_value
                  : JSON.parse(item.field_value)
              ),
            }}
          />
          {/* <img
            className="video-thumb my-2"
            src={API.mediaView + item.file_path}
            alt="form-dep"
          /> */}

          <div
            className={
              item.file_alignment === "left"
                ? "img-divs divs-left-algment"
                : item.file_alignment === "center"
                ? "img-divs divs-center-algment"
                : item.file_alignment === "right"
                ? "img-divs divs-right-algment"
                : null
            }
          >
            <img
              className={
                item.file_alignment === "left" && item.file_size === "small"
                  ? "video-thumb my-2 imgs-left-algment image-sizes-small"
                  : item.file_alignment === "left" &&
                    item.file_size === "medium"
                  ? "video-thumb my-2 imgs-left-algment image-sizes-medm"
                  : item.file_alignment === "left" && item.file_size === "large"
                  ? "video-thumb my-2 imgs-left-algment image-sizes-large"
                  : item.file_alignment === "center" &&
                    item.file_size === "small"
                  ? "video-thumb my-2 imgs-center-algment image-sizes-small"
                  : item.file_alignment === "center" &&
                    item.file_size === "medium"
                  ? "video-thumb my-2 imgs-center-algment image-sizes-medm"
                  : item.file_alignment === "center" &&
                    item.file_size === "large"
                  ? "video-thumb my-2 imgs-center-algment image-sizes-large"
                  : item.file_alignment === "right" &&
                    item.file_size === "small"
                  ? "video-thumb my-2 imgs-right-algment image-sizes-small"
                  : item.file_alignment === "right" &&
                    item.file_size === "medium"
                  ? "video-thumb my-2 imgs-right-algment image-sizes-medm"
                  : item.file_alignment === "right" &&
                    item.file_size === "large"
                  ? "video-thumb my-2 imgs-right-algment image-sizes-large"
                  : null
              }
              src={API.mediaView + item.file_path}
              alt="form-img"
            />
          </div>
        </div>
      );
    } else if (item.field_type_id === 11) {
      return (
        <div className="row w-100">
          <div className="col-lg-4">
            {/*<div className="document-view">
              <div className="head-buttons">
                <a href="#">
                  <img
                    src={File}
                    alt="copy"
                    className="create-icon mb-0 me-2"
                  />{" "}
                  {item?.file_path?.split('_')?.pop()[0]?.toUpperCase() + item?.file_path?.split('_')?.pop()?.slice(1)}
                </a>
                <a onClick={() => { downloadFile(API.mediaView + item?.file_path) }}>
                  <img
                    src={Download}
                    alt="copy"
                    className="create-icon mb-0 me-2"
                  />{" "}
                  Download
                </a>
              </div>
              <div
                dangerouslySetInnerHTML={{
                  __html: draftToHtml(JSON.parse(item.field_value)),
                }}
              />
              <div className="d-img">
                {/* <Document file={pdf} onLoadSuccess={onDocumentLoadSuccess}>
                                                    <Page pageNumber={pageNumber} />
                                                </Document> 
                <img src={Doc} alt="document" className="doc-img" />
              </div>
            </div>*/}
            <div className="btnAlg_same mt-0">
              <button className="btn btn-primary my-2 review-btn">
                Review Document
              </button>
            </div>
          </div>
        </div>
      );
    } else if (item.field_type_id === 1 || item.field_type_id === 2) {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: draftToHtml(
              location?.state?.formData !== undefined
                ? item.field_value
                : JSON.parse(item.field_value)
            ),
          }}
        >
          {/* {console.log("Ttteee", JSON.parse(item))} */}
          {/* dangerouslySetInnerHTML={{
            __html: draftToHtml(
              JSON.parse(convertToRaw(item.heading.getCurrentContent()))
            ),
          }} */}
        </div>
      );
    } else if (item.field_type_id === 6) {
      return (
        <div style={{ marginBottom: "25px" }}>
          <div
            dangerouslySetInnerHTML={{
              __html: draftToHtml(
                location?.state?.formData !== undefined
                  ? item.field_value
                  : JSON.parse(item.field_value)
              ),
            }}
          />
          <div class="form-floating ">
            <textarea
              className="form-control "
              placeholder="Leave a comment here"
              id="floatingTextarea"
              style={{ height: "20px !important" }}
            ></textarea>
            <label htmlFor="floatingTextarea " className=" font-enter-color">
              Enter text here
            </label>
          </div>
        </div>
      );
    } else if (item.field_type_id === 14) {
      console.log(index, i, j);
      return location.state?.chatbotId !== undefined ? (
        <div style={{ marginBottom: "25px" }}>
          <div
            dangerouslySetInnerHTML={{
              __html: draftToHtml(
                location?.state?.formData !== undefined
                  ? item.field_value
                  : JSON.parse(item.field_value)
              ),
            }}
          />
          <div class="form-floating ">
            {/* <textarea
              className="form-control "
              placeholder="Leave a comment here"
              id="floatingTextarea"
              style={{ height: "20px !important" }}
            ></textarea>*/}
            <div
              class="input-group-append pass-div-width secure-field  "
              style={{ height: "60px" }}
            >
              <input
                type={
                  location?.state?.formData !== undefined
                    ? formData[index].isVisible === true
                      ? "text"
                      : "password"
                    : formData[index]?.section_forms[i]?.fields[0][j]
                        ?.isVisible === true
                    ? "text"
                    : "password"
                }
                className="form-control pass-inpt"
                name="password"
                placeholder="Enter text here"
              />
              <button
                type="button"
                class="btn eye-bttn"
                data-toggle="password"
                onClick={() => {
                  let data = [...formData];
                  data.map((item1, a) => {
                    if (a === index) {
                      item1.section_forms.map((item2, b) => {
                        if (b === i) {
                          for (let c = 0; c < item2.fields[0].length; c++) {
                            if (c === j) {
                              item2.fields[0][c].isVisible =
                                !formData[index]?.section_forms[i]?.fields[0][j]
                                  ?.isVisible;
                            }
                          }
                        }
                      });
                    }
                  });
                  setFormData(data);
                }}
              >
                <img
                  src={
                    location?.state?.formData !== undefined
                      ? formData[index].isVisible === false
                        ? eye
                        : eyeview
                      : formData[index]?.section_forms[i]?.fields[0][j]
                          ?.isVisible === false
                      ? eye
                      : eyeview
                  }
                  alt="test"
                  className="eye-img"
                />
                {/* <img src={eyeview} alt="test" className="eye-img" />*/}
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div style={{ marginBottom: "25px" }}>
          <div
            dangerouslySetInnerHTML={{
              __html: draftToHtml(
                location?.state?.formData !== undefined
                  ? item.field_value
                  : JSON.parse(item.field_value)
              ),
            }}
          />
          <div class="form-floating ">
            {/* <textarea
              className="form-control "
              placeholder="Leave a comment here"
              id="floatingTextarea"
              style={{ height: "20px !important" }}
            ></textarea>*/}
            <div
              class="input-group-append pass-div-width secure-field  "
              style={{ height: "60px" }}
            >
              <input
                type={
                  location.state?.tempId !== undefined ||
                  location.state?.formId !== undefined ||
                  location.state?.formTempId !== undefined ||
                  location.state?.formid !== undefined
                    ? formData[index]?.isVisible === true
                      ? "text"
                      : "password"
                    : formData[index]?.template_forms[i]?.fields[0][j]
                        ?.isVisible === true
                    ? "text"
                    : formData[index]?.template_forms[i]?.fields[0][j]
                        ?.isVisible === undefined
                    ? "password"
                    : "password"
                }
                className="form-control pass-inpt"
                name="password"
                placeholder="Enter text here"
              />
              <button
                type="button"
                class="btn eye-bttn"
                data-toggle="password"
                onClick={() => {
                  let data = [...formData];
                  data.map((item1, a) => {
                    if (a === index) {
                      item1.template_forms.map((item2, b) => {
                        if (b === i) {
                          for (let c = 0; c < item2.fields[0].length; c++) {
                            if (c === j) {
                              item2.fields[0][c].isVisible =
                                !formData[index]?.template_forms[i]?.fields[0][
                                  j
                                ]?.isVisible;
                            }
                          }
                        }
                      });
                    }
                  });
                  setFormData(data);
                }}
              >
                <img
                  src={
                    location.state?.tempId !== undefined ||
                    location.state?.formId !== undefined ||
                    location.state?.formTempId !== undefined ||
                    location.state?.formid !== undefined
                      ? formData[index]?.isVisible === false
                        ? eye
                        : eyeview
                      : formData[index]?.template_forms[i]?.fields[0][j]
                          ?.isVisible === false
                      ? eye
                      : eyeview
                  }
                  alt="test"
                  className="eye-img"
                />
                {/* <img src={eyeview} alt="test" className="eye-img" />*/}
              </button>
            </div>
          </div>
        </div>
      );
    }
  };

  const scrollToSection = (index) => {
    const element = document.getElementById("section" + index);
    if (element) {
      console.log(element);
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div className="container-fluid">
      {formData.length !== 0 && (
        <div>
          <div className="fixHeader candPrv">
            <div className="row">
              <div className="col-lg-2 col-md-3 sideCont">
                <div className="hd-left">
                  <img
                    src={Menu}
                    alt="test"
                    className="preview-bck-icon"
                    onClick={() => {
                      let prevRoute = localStorage.getItem("prevRoute");
                      prevRoute === "createTemplate"
                        ? navigate("/dashboard/onboarding/templates")
                        : prevRoute === "createForm"
                        ? navigate("/dashboard/onboarding/edit-forms")
                        : prevRoute === "templateEdit"
                        ? navigate("/dashboard/onboarding/templates")
                        : prevRoute === "sectionTemplateEdit"
                        ? navigate(
                            "/dashboard/onboarding/edit-onboarding-template",
                            {
                              state: { item: tempData },
                            }
                          )
                        : prevRoute === "isFormEdit"
                        ? navigate("/dashboard/onboarding/edit-forms")
                        : navigate(prevRoute, {
                            state: { item: tempData },
                          });
                    }}
                  />
                </div>
              </div>
              <div className="w-100 logo-sec">
                <div className="logoCent logo-sec">
                  {companyLogo !== null && (
                    <img
                      src={API.avenuView + companyLogo}
                      alt="logo"
                      className="logo-inner mb-0 me-2"
                    />
                  )}
                </div>
                <div className="logoSide logo-sec">
                  <img
                    src={LogoPw}
                    alt="copy"
                    className="logo-inner mb-0 me-2"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row px-4 topSpce_view">
            {/* {location?.state?.tempId !== undefined &&
          location?.state?.formId !== undefined && */}
            {sections?.length !== 0 && (
              <div className="col-lg-2 col-md-3 sideCont">
                <div className="sidebarFixs">
                  <div className="sideScroll">
                    <div
                      className="action-itms full-drp  inner-scrll create-comp-scroll scrlHe-tab  "
                      style={{ alignitems: "flex-start" }}
                    >
                      <ul className="status-ind spaceBx">
                        {sections?.map((item, index) => {
                          return (
                            item?.section_forms?.length !== 0 && (
                              <li
                                onClick={() => {
                                  scrollToSection(index);
                                }}
                              >
                                <a className="review-pre-cand-link">
                                  <img
                                    src={success}
                                    alt="copy"
                                    className="create-icon mb-0 me-2"
                                  />
                                  {location.state?.chatbotId !== undefined
                                    ? item?.section_name
                                    : item?.template_section_name}
                                </a>
                              </li>
                            )
                          );
                        })}
                      </ul>
                    </div>

                    <div className="dateWrap text-center w-100 my-2">
                      <p className="dates">
                        {deadLineDays}{" "}
                        {deadLineDays > 1
                          ? " days remaining"
                          : " day remaining"}{" "}
                        <span>{moment(deadLine).format("DD MMM YYYY")}</span>
                      </p>
                    </div>

                    <div className="progress custom me-3 w-100 mt-4">
                      <div
                        className="progress-bar2"
                        role="progressbar"
                        aria-valuenow="0"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {pdfViewer ? (
              <div className="col-lg-10 col-md-9 rightCont">
                {/* <FillablePdf item={pdfViewerItem} setPdfViewer={setPdfViewer} /> */}
                <FillablePdf
                  item={componentItem}
                  setPdfViewer={setPdfViewer}
                  currentPath={parts[1]}
                />
              </div>
            ) : location?.state?.tempId !== undefined ||
              location?.state?.formId !== undefined ||
              location?.state?.formid !== undefined ||
              location?.state?.formTempId !== undefined ? (
              <div className="col-lg-12 col-md-9 rightCont">
                <div
                  className="action-itms fulWid full-drp flex-column collap-main mb-3"
                  id={"section" + 0}
                >
                  <div
                    className="w-100 collap-head collapsed"
                    data-bs-toggle="collapse"
                    href={`#outerCollapse${0}`}
                  >
                    <div className="d-flex justify-content-between">
                      <div className="hd-can-review neSp create-form-wrp">
                        <h4>
                          <img
                            src={success}
                            alt="copy"
                            className="create-icon mb-0 me-2"
                          />
                          New Section
                        </h4>
                      </div>

                      <div className="task-count mr-0">
                        <div className="progress custom me-3">
                          <div
                            className="progress-bar2"
                            role="progressbar"
                            aria-valuenow="0"
                            aria-valuemin="0"
                            aria-valuemax="100"
                          ></div>
                        </div>
                        <div className="task-itms me-3">
                          <sapn>0 of 1 tasks</sapn>
                        </div>
                        <button className="select-btn">
                          <img
                            src={dropdown}
                            alt="test"
                            className="drp top-drp "
                          />
                        </button>
                      </div>
                    </div>

                    <p className="mb-0 pt-2 sub-head-color">Subtitle</p>
                    {/* <div className="content-area">
                        <p></p>
                      </div> */}
                  </div>
                  <div
                    className="contents-sub w-100 mt-3 collapse"
                    id={`outerCollapse${0}`}
                  >
                    <div className="action-itms fulWid full-drp w-100 flex-column exit mb-4">
                      <div
                        className="collap-Subhead w-100 border-0 p-0 mb-0 collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target={`#innerCollapse${0}`}
                      >
                        <div className="d-flex justify-content-between w-100">
                          <div className="hd-can-review neSp create-form-wrp">
                            <h4>
                              <img
                                src={success}
                                alt="copy"
                                className="create-icon mb-0 me-2"
                              />
                              {tempData.title}
                            </h4>
                          </div>

                          <div className="task-count mr-0">
                            <div className="task-itms me-3">
                              {/* <sapn>5 May, 2023</sapn> */}
                            </div>
                            <button className="select-btn">
                              <img
                                src={dropdown}
                                alt="test"
                                className="drp top-drp "
                              />
                            </button>
                          </div>
                        </div>

                        <p className="mb-0 pb-0 review-texts">
                          {tempData?.subtitle}
                        </p>
                      </div>
                      <div
                        className="contents-sub fulWid w-100 pl-0 pr-0 collapse"
                        id={`innerCollapse${0}`}
                      >
                        <div className="w-100">
                          {tempData?.fields?.map((value, index) => (
                            <div className="my-2">
                              {console.log(value, index)}
                              {value.employee_view === 1 &&
                                convert(value, 0, 0, 0)}
                            </div>
                          ))}
                          <div className="col-lg-12 d-flex align-items-center justify-content-end">
                            <div className="form-floating mb-0 d-flex justify-content-end">
                              <button className="next-btn rounded p-2 btnSty mt-2">
                                Next Form
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : location.state?.chatbotId !== undefined ? (
              <div className="col-lg-10 col-md-9 rightCont">
                {formData?.map((item, index) => {
                  return (
                    item?.section_forms?.length !== 0 && (
                      <div
                        className="action-itms fulWid full-drp flex-column collap-main mb-3"
                        id={"section" + index}
                      >
                        <div
                          className="w-100 collap-head collapsed"
                          data-bs-toggle="collapse"
                          href={`#outerCollapse${item.id}`}
                        >
                          <div className="d-flex justify-content-between">
                            <div className="hd-can-review neSp create-form-wrp">
                              <h4>
                                <img
                                  src={success}
                                  alt="copy"
                                  className="create-icon mb-0 me-2"
                                />
                                {item.section_name}
                              </h4>
                            </div>

                            <div className="task-count mr-0">
                              <div className="progress custom me-3">
                                <div
                                  className="progress-bar2"
                                  role="progressbar"
                                  aria-valuenow="0"
                                  aria-valuemin="0"
                                  aria-valuemax="100"
                                ></div>
                              </div>
                              <div className="task-itms me-3">
                                <sapn>
                                  0 of {item?.section_forms?.length} tasks
                                </sapn>
                              </div>
                              <button className="select-btn">
                                <img
                                  src={dropdown}
                                  alt="test"
                                  className="drp top-drp "
                                />
                              </button>
                            </div>
                          </div>

                          <p className="mb-0 pt-2 sub-head-color">
                            {item?.subtitle}
                          </p>
                          {/* <div className="content-area">
                        <p></p>
                      </div> */}
                        </div>
                        <div
                          className="contents-sub w-100 mt-3 collapse"
                          id={`outerCollapse${item.id}`}
                        >
                          {item?.section_forms?.map((data, i) => {
                            return (
                              <div className="action-itms fulWid full-drp w-100 flex-column exit mb-4">
                                <div
                                  className="collap-Subhead w-100 border-0 p-0 mb-0 collapsed"
                                  data-bs-toggle="collapse"
                                  data-bs-target={`#innerCollapse${data.id}`}
                                >
                                  <div className="d-flex justify-content-between w-100">
                                    <div className="hd-can-review neSp create-form-wrp">
                                      <h4>
                                        <img
                                          src={success}
                                          alt="copy"
                                          className="create-icon mb-0 me-2"
                                        />
                                        {data?.title}
                                      </h4>
                                    </div>

                                    <div className="task-count mr-0">
                                      <div className="task-itms me-3">
                                        {/* <sapn>5 May, 2023</sapn> */}
                                      </div>
                                      <button className="select-btn">
                                        <img
                                          src={dropdown}
                                          alt="test"
                                          className="drp top-drp "
                                        />
                                      </button>
                                    </div>
                                  </div>

                                  <p className="mb-0 pb-0 review-texts">
                                    {data?.subtitle == "converted document" ||
                                    data?.subtitle == "adminI9Pdf"
                                      ? ""
                                      : data?.subtitle}
                                  </p>
                                </div>
                                <div
                                  className="contents-sub fulWid w-100 pl-0 pr-0 collapse"
                                  id={`innerCollapse${data.id}`}
                                >
                                  <div className="w-100">
                                    {data?.template_type === "w4-form" ? (
                                      <W4form
                                        review={false}
                                        data={data}
                                        fetchSections={fetchSections}
                                      />
                                    ) : data?.template_type === "i-9form" ? (
                                      <I9form
                                        review={false}
                                        data={data}
                                        fetchSections={fetchSections}
                                      />
                                    ) : data?.template_type === "W4Sc-form" ? (
                                      <W4South
                                        review={false}
                                        data={data}
                                        fetchSections={fetchSections}
                                      />
                                    ) : (
                                      data.fields[0]?.map((value, j) => (
                                        <div className="my-2  ">
                                          {value.employee_view === 1 &&
                                            convert(value, index, i, j)}
                                        </div>
                                      ))
                                    )}
                                    {data.fields[0]?.field_type_id !== 13 && (
                                      <div className="col-lg-12 d-flex align-items-center justify-content-end">
                                        <div className="form-floating mb-0 d-flex justify-content-end">
                                          <button className="next-btn rounded p-2 btnSty mt-2">
                                            {item.section_forms?.length ===
                                            i + 1
                                              ? "Submit Form"
                                              : "Next Form"}
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )
                  );
                })}
              </div>
            ) : (
              <div className="col-lg-10 col-md-9 rightCont">
                {sections?.map((item, index) => {
                  return (
                    item?.template_forms?.length !== 0 && (
                      <div
                        className="action-itms fulWid full-drp flex-column collap-main mb-3"
                        id={"section" + index}
                      >
                        <div
                          className="w-100 collap-head collapsed"
                          data-bs-toggle="collapse"
                          href={`#outerCollapse${item.id}`}
                        >
                          <div className="d-flex justify-content-between">
                            <div className="hd-can-review neSp create-form-wrp">
                              <h4>
                                <img
                                  src={success}
                                  alt="copy"
                                  className="create-icon mb-0 me-2"
                                />
                                {item?.template_section_name}
                              </h4>
                            </div>

                            <div className="task-count mr-0">
                              <div className="progress custom me-3">
                                <div
                                  className="progress-bar2"
                                  role="progressbar"
                                  aria-valuenow="0"
                                  aria-valuemin="0"
                                  aria-valuemax="100"
                                ></div>
                              </div>
                              <div className="task-itms me-3">
                                <sapn>
                                  0 of {item?.template_forms?.length} tasks
                                </sapn>
                              </div>
                              <button className="select-btn">
                                <img
                                  src={dropdown}
                                  alt="test"
                                  className="drp top-drp "
                                />
                              </button>
                            </div>
                          </div>

                          <p className="mb-0 pt-2 sub-head-color">
                            {item?.subtitle}
                          </p>
                          {/* <div className="content-area">
                        <p></p>
                      </div> */}
                        </div>
                        <div
                          className="contents-sub w-100 mt-3 collapse"
                          id={`outerCollapse${item.id}`}
                        >
                          {item?.template_forms?.map((data, i) => {
                            return (
                              <div className="action-itms fulWid full-drp w-100 flex-column exit mb-4">
                                <div
                                  className="collap-Subhead w-100 border-0 p-0 mb-0 collapsed"
                                  data-bs-toggle="collapse"
                                  data-bs-target={`#innerCollapse${data.id}`}
                                >
                                  <div className="d-flex justify-content-between w-100">
                                    <div className="hd-can-review neSp create-form-wrp">
                                      <h4>
                                        <img
                                          src={success}
                                          alt="copy"
                                          className="create-icon mb-0 me-2"
                                        />
                                        {data?.title}
                                      </h4>
                                    </div>

                                    <div className="task-count mr-0">
                                      <div className="task-itms me-3">
                                        {/* <sapn>5 May, 2023</sapn> */}
                                      </div>
                                      <button className="select-btn">
                                        <img
                                          src={dropdown}
                                          alt="test"
                                          className="drp top-drp "
                                        />
                                      </button>
                                    </div>
                                  </div>

                                  <p className="mb-0 pb-0 review-texts">
                                    {data?.subtitle == "converted document" ||
                                    data?.subtitle == "adminI9Pdf"
                                      ? ""
                                      : data?.subtitle}
                                  </p>
                                </div>
                                <div
                                  className="contents-sub fulWid w-100 pl-0 pr-0 collapse"
                                  id={`innerCollapse${data.id}`}
                                >
                                  <div className="w-100">
                                    {data?.template_type === "w4-form" ? (
                                      <W4form
                                        review={false}
                                        data={data}
                                        fetchSections={fetchSections}
                                      />
                                    ) : data?.template_type === "i-9form" ? (
                                      <I9form
                                        review={false}
                                        data={data}
                                        fetchSections={fetchSections}
                                      />
                                    ) : data?.template_type === "W4Sc-form" ? (
                                      <W4South
                                        review={false}
                                        data={data}
                                        fetchSections={fetchSections}
                                      />
                                    ) : (
                                      data.fields?.map((value, j) => (
                                        <div className="my-2  ">
                                          {value.employee_view === 1 &&
                                            convert(value, index, i, j)}
                                        </div>
                                      ))
                                    )}
                                    {data.fields[0]?.field_type_id !== 13 && (
                                      <div className="col-lg-12 d-flex align-items-center justify-content-end">
                                        <div className="form-floating mb-0 d-flex justify-content-end">
                                          <button className="next-btn rounded p-2 btnSty mt-2">
                                            {item.section_forms?.length ===
                                            i + 1
                                              ? "Submit Form"
                                              : "Next Form"}
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )
                  );
                })}
              </div>
            )}
          </div>
          {loader && <Spinner />}
        </div>
      )}
    </div>
  );
};

export default Candidate;
